import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CTAStrip from '../../components/feature/CTAStrip';
import { useNavigate } from 'react-router-dom';

const features = [
  {ico:'👁',title:'Real-Time Inventory',desc:'Live SKU-level counts with automated alerts before stockouts happen.'},
  {ico:'📍',title:'Live Order Tracking',desc:'Continuous tracking chain with milestone notifications for your team and customers.'},
  {ico:'📈',title:'Inventory Analytics',desc:'Velocity analysis, dead stock ID, seasonal forecasting, and automated reorder calculations.'},
  {ico:'💻',title:'Performance Dashboards',desc:'Order accuracy, fulfillment time, delivery rate, cost per order. Downloadable reports.'},
  {ico:'🔌',title:'Multi-Channel Integration',desc:'Connect Shopify, WooCommerce, Jumia, Konga with no-code connectors.'},
  {ico:'🏪',title:'Merchant Portal',desc:'Manage inventory, inbound shipments, support tickets, and invoices, available 24/7.'},
  {ico:'⚠',title:'Smart Alerts',desc:'Configurable alerts for low stock, delays, and failed deliveries via SMS, email, or in-app.'},
  {ico:'🔒',title:'Audit Trail & Compliance',desc:'Every movement timestamped and permanently logged. Full chain of custody.'},
  {ico:'📱',title:'Mobile Operations',desc:'Handheld scanners create real-time data at every warehouse touchpoint.'},
];

export default function TechnologyPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-thl-dark">
      <Navbar />
      <div className="page-header pt-28 pb-16 px-6">
        <div className="page-header-grid" />
        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="flex items-center gap-2 mb-3 text-xs text-white/40">
            <button onClick={()=>navigate('/')} className="hover:text-white cursor-pointer">Home</button>
            <span>/</span><span className="text-white/60">Technology</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">The THL Logistics Platform</h1>
          <p className="text-white/50 max-w-xl">Real-time data, intelligent automation, complete supply chain visibility.</p>
        </div>
      </div>
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <p className="eyebrow">Features</p>
          <h2 className="section-heading mb-12">Intelligence in Every Operation</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.map(f=>(
              <div key={f.title} className="bg-thl-dark3 border border-thl-border rounded-xl p-6 hover:border-thl-red/30 transition-all">
                <div className="text-3xl mb-4">{f.ico}</div>
                <h3 className="text-white font-bold text-base mb-2">{f.title}</h3>
                <p className="text-white/50 text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-10 text-center">
            <button onClick={()=>navigate('/contact')} className="btn-primary">Book a Live Demo →</button>
          </div>
        </div>
      </section>
      <CTAStrip headline="See It In Action" sub="Book a live demo and see your logistics data come to life in real time." btn1="Book a Demo →" btn2="Get a Quote" btn2Path="/contact" />
      <Footer />
    </div>
  );
}
